define('model/association.model',['require','exports','module','fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseModel         = require('fukit').BaseModel;

  var AssociationModel = BaseModel.extend({
    radioRequests: {
      'models AssociationModel': '@constructor',
    },

    urlRootTemplate: '/api/v2/coi/disclosure',

    defaults: {
      active: true,
    },
  });

  module.exports = AssociationModel;
});

